import { ButtonsSvg, HomeSvg, MapsSvg, EmailSvg, UsersComponentSvg, BlogSvg } from '../../Data/svgIcons';
export const MENUITEMADMINS = [
    {
        menutitle: 'DashBoards',
        Items: [
            { path: `${process.env.PUBLIC_URL}/dashboard`, bookmark: true, icon: HomeSvg, title: 'Dashboards', type: 'link' }
        ]
    },
    {
        menutitle: 'Daftar Perawatan',
        Items: [
            { path: `${process.env.PUBLIC_URL}/treatments`, bookmark: true, icon: BlogSvg, title: 'Daftar Perawatan', type: 'link' }
        ]
    },
    {
        menutitle: 'Daftar Dokter',
        Items: [
            { path: `${process.env.PUBLIC_URL}/doctors`, bookmark: true, icon: UsersComponentSvg, title: 'Daftar Dokter', type: 'link' }
        ]
    },
    {
        menutitle: 'Pengaturan Jadwal',
        Items: [
            { path: `${process.env.PUBLIC_URL}/settings`, bookmark: true, icon: ButtonsSvg, title: 'Pengaturan Jadwal', type: 'link' }
        ]
    },
    {
        menutitle: 'Daftar Reservasi',
        Items: [
            { path: `${process.env.PUBLIC_URL}/orders`, icon: EmailSvg, type: 'link', active: false, title: 'Daftar Reservasi' },
        ]
    },
];